import './polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import 'moment-timezone';

import './initializers/yup';
import './initializers/yup7';
import './initializers/i18next';
import './initializers/moment';
import initializePostHog from './initializers/posthog';

import App from './App';
import { HelmetProvider } from 'react-helmet-async';

import './initializers/flatpickr';
import './vendor/dashkit/js/chart';
import './vendor/dashkit/css/theme.bundle.css';
import './vendor/dashkit/css/libs.bundle.css';
import './vendor/dashkit/css/override.css';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { RollbarProvider } from './apps/dashboard/context/Rollbar';

// Here is a fix to `unsafe-eval` problem caused by CSP
// from here https://stephencharlesweiss.com/unsafe-eval-regenerator-runtime
(globalThis as any).regeneratorRuntime = undefined;

function registerServiceWorker() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .catch((error) => {
          console.error('Service Worker registration failed:', error);
        });
    });
  }
}

registerServiceWorker();
initializePostHog();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root not found');
}

// Note: the tree is intentionally not wrapped in <StrictMode> — react-hook-form
// v5 and react-router v5 both break under its dev-only remount. See App.tsx for
// the full rationale and the regression tests that pin it down.
createRoot(container).render(
  <HelmetProvider>
    <RollbarProvider>
      <App />
      {/*
        position/newestOnTop mirror react-toast-notifications' ToastProvider
        defaults (placement 'top-right', newestOnTop false) so the swap keeps
        toasts where users expect them.
      */}
      <ToastContainer position="top-right" newestOnTop={false} />
    </RollbarProvider>
  </HelmetProvider>,
);
